/**
 *  @shelf-version: 1.0.0
 */

import GTM from './gtm'

export default GTM
